module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_concept_01-97184c272783a03a1b8a6907c47219b4.jpg";